export default __webpack_public_path__ + "static/media/Comprehend.62c38c8f.svg";